AFRAME.registerComponent('tradingview-universal-chart', {
    schema: {
        intervals: { type: 'number', default: 200 },
        multiplier: { type: 'string', default: '14' },
        timespan: { type: 'string', default: 'day' },
        startDate: { type: 'string', default: '' },
        endDate: { type: 'string', default: '' },
        stockData: { type: 'string', default: '' },
        dataInterval: { type: 'string', default: '1d' },
        candlestickSpacing: { type: 'number', default: 0.01 },
        width: { type: 'number', default: 200 },
        height: { type: 'number', default: 320 },
        scale: { type: 'string', default: '11 11 11' },
        position: { type: 'string', default: '0 0 -0.48' },
        type: { type: 'string', default: 'mountain', oneOf: ['mountain', 'candlestick', 'line'] },
        chartMathFunction: { type: 'string', default: 'Linear', oneOf: ['Log', 'Linear'] },
        volumeHeight: { type: 'number', default: 0.3 },
        paneGap: { type: 'number', default: 0.2 },
        showEvents: { type: 'boolean', default: false },
        isETTimeZone: { type: 'boolean', default: true },
        secondarySeriesType: { type: 'string', default: 'volume', oneOf: ['volume', 'dividend', 'sip'] },
    },

    init: async function () {
        if (__LOG_INFO__) AppLog.info('[TradingView Universal] Initializing v2 component');
        this.originalWidth = this.data.width;
        this.originalHeight = this.data.height;

        this.applyDataFromStorage();

        this.dataIntervalListener = (event) => {
            const { interval } = event.detail;
            if (__LOG_INFO__) AppLog.info(`[TradingView Universal] Received data-interval: ${interval}`);
            this.el.setAttribute('tradingview-universal-chart', 'dataInterval', interval.toLowerCase());
        };
        this.el.sceneEl.addEventListener('data-interval', this.dataIntervalListener);

        this.boundOnSearchModeChanged = this.onSearchModeChanged.bind(this);
        this.el.sceneEl.addEventListener('search-mode-state', this.boundOnSearchModeChanged);

        const container = document.querySelector('#right-live-chart');
        if (container) container.classList.add('show');

        const noSelectedStockPopup = document.querySelector('#no-selected-stock-message');
        if (noSelectedStockPopup) noSelectedStockPopup.classList.remove('show');

        this.updateChartZoom();
        this.boundUpdateChartZoom = this.updateChartZoom.bind(this);
        window.addEventListener('resize', this.boundUpdateChartZoom);

        if (typeof window.TradingViewCore === 'undefined') {
            if (__LOG_ERROR__) AppLog.error('[TradingView Universal] TradingViewCore not found. Make sure TradingViewCore.js is included.');
            return;
        }
        this.core = new window.TradingViewCore(this.el, container, this.data);
        await this.core.init();
    },

    applyDataFromStorage: function () {
        if (typeof getCacheItem === 'function') {
            try {
                const popupSettings = getCacheItem('rightConfigurePopupSettings');
                if (popupSettings) {
                    if (this.data.type !== popupSettings.chartType && typeof popupSettings.chartType === 'string') {
                        this.data.type = popupSettings.chartType.toLowerCase();
                    }
                    if (this.data.showEvents !== popupSettings.showEvents && typeof popupSettings.showEvents === 'boolean') {
                        this.data.showEvents = popupSettings.showEvents;
                    }
                }
            } catch (e) {
                if (__LOG_WARN__) AppLog.warn('[TradingView Universal] Failed to read from popup settings');
            }
        }
    },

    update: async function (oldData) {
        if (oldData && typeof oldData === 'object') {
            if (oldData.width !== this.data.width) {
                this.originalWidth = this.data.width;
            }
            if (oldData.height !== this.data.height) {
                this.originalHeight = this.data.height;
            }
        }
        if (!this.core) return;
        const changedKeys = Object.keys(this.data).filter(k => this.data[k] !== oldData[k]);
        if (changedKeys.includes('stockData')) {
            const noSelected = document.querySelector('#no-selected-stock-message');
            const htmlC = document.querySelector('#right-live-chart');
            if (htmlC) htmlC.classList.add('show');
            if (noSelected) noSelected.classList.remove('show');
        }
        this.core.config = this.data; // Ensure core has the latest config reference
        await this.core.update(oldData);

        if (window.StockStormDesktopScale?.resizeRightPanelChart) {
            window.StockStormDesktopScale.resizeRightPanelChart();
        }
    },

    updateChartZoom: function () {
        const isOverlay = document.getElementById('center-chart-overlay');
        if (isOverlay) {
            const chartElem = document.querySelector('.chart-container');
            if (chartElem) chartElem.style.zoom = '1';
            return;
        }

        const container = document.querySelector('#right-container');
        if (!container) return;

        const isDesktop = !document.documentElement.classList.contains('desktop-portrait-accepted');
        let containerWidth;

        if (isDesktop) {
            const mainContainer = document.getElementById('main-container');
            containerWidth = mainContainer ? (mainContainer.clientWidth * 0.25 - 40) : 320;
        } else {
            containerWidth = container.getBoundingClientRect().width - 28;
        }

        const aspectPerChart = containerWidth / this.data.width;
        const chartElem = document.querySelector('.chart-container');
        if (chartElem && aspectPerChart) {
            chartElem.style.zoom = (aspectPerChart).toString();
        }
    },

    onSearchModeChanged: function (event) {
        this.updateSize(event.detail);
    },
    
    updateSize: function (isFullScreen) {
        const applySize = () => {
            const chart = this.core?.chart;
            if (!chart) {
                return;
            }

            if (isFullScreen &&
                document.documentElement.classList.contains('desktop-right-chart-fullscreen') &&
                window.StockStormDesktopScale?.resizeRightPanelChart) {
                window.StockStormDesktopScale.resizeRightPanelChart();
                return;
            }

            const chartContainer = document.querySelector('.live-chart-tab .chart-container');
            const chartContent = chartContainer?.querySelector('.chart-content');
            if (chartContent) {
                chartContent.style.height = '';
            }

            const isDesktopPortrait = document.documentElement.classList.contains('desktop-portrait-accepted');
            const newWidth = (this.originalWidth || 420) - 8;
            const newHeight = (this.originalHeight || 285) - (isDesktopPortrait ? 125 : 115);

            chart.resize(newWidth, newHeight);
            this.updateChartZoom();
        };

        if (isFullScreen) {
            requestAnimationFrame(() => {
                requestAnimationFrame(applySize);
            });
            [120, 400, 700].forEach((delay) => window.setTimeout(applySize, delay));
            return;
        }

        window.setTimeout(applySize, 600);
    },

    remove: function () {
        if (__LOG_INFO__) AppLog.info('[TradingView Universal] Component being removed');
        if (this._updateSizeTimer) {
            clearTimeout(this._updateSizeTimer);
            this._updateSizeTimer = null;
        }
        if (this.dataIntervalListener) {
            this.el.sceneEl.removeEventListener('data-interval', this.dataIntervalListener);
            this.dataIntervalListener = null;
        }
        if (this.boundUpdateChartZoom) {
            window.removeEventListener('resize', this.boundUpdateChartZoom);
            this.boundUpdateChartZoom = null;
        }
        if (this.boundOnSearchModeChanged) {
            this.el.sceneEl.removeEventListener('search-mode-state', this.boundOnSearchModeChanged);
            this.boundOnSearchModeChanged = null;
        }
        if (this._panelSizeObserver) this._panelSizeObserver.disconnect();
        if (this.core) {
            this.core.remove();
            this.core = null;
        }
    }
});
